export const locale = {
    lang: 'en',
    data: {
        EMAIL_ALERT_SETTINGS: {
            LISTINGS: {
                TITLE: 'Listings',
                ACTIVITIES: 'Activities',
                ADDED: 'Added',
                LIKED: 'Liked',
                DISLIKED: 'Not For Me',
                REMOVED: 'Removed',
                MESSAGES: 'Messages',
            },
            APPOINTMENTS: {
                TITLE: 'Appointments',
                CONFIRMATIONS: 'Confirmations',
                REQUESTS: 'Requests',
                DECLINES: 'Declines'
            },
            OPTIONS: {
                DAILY: 'Daily (at 6pm EST)',
                REAL_TIME: 'Real Time',
                DISABLED: 'Disabled'
            },
            NOTIFICATION_TYPE: {
                EMAIL: 'Email',
                SMS: 'SMS'
            },
            ERRORS: {
                INVALID_MY_PHONE: 'To receive text notifications, please add a mobile phone number to your account.',
                INVALID_PHONE: 'To receive text notifications, please add a mobile phone number to account.'
            }
        }
    }
};